import Button from '@Components/Buttons/Button'
import React from 'react'
import './index.scss'

export interface DisputeOptionItemProps {
    title: string
    body: string
    onClick: () => void
    buttonText: string
    disabled?: boolean
    dataTooltipId?: string
}

const DisputeOptionItem = (props: DisputeOptionItemProps) => {
    const { title, body, onClick, buttonText, disabled, dataTooltipId } = props

    return (
        <div className="dispute-option-item">
            <div className="top-section">
                <div className="top-section-header">
                    <h6>{title}</h6>
                </div>
                <div className="top-section-body">
                    <p>{body}</p>
                </div>
            </div>
            <div className="dispute-option-button-container" data-tooltip-id={dataTooltipId}>
                <Button type="primary" disabled={disabled} mainColor onClick={onClick}>
                    {buttonText}
                </Button>
            </div>
        </div>
    )
}

export default DisputeOptionItem
